import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily } from '@daily-co/daily-react';
import { pageAtom, myNftAtom, displayNameAtom } from '../../State';
import { useRecoilState, useRecoilValue } from 'recoil';
import { format } from 'date-fns';
import NFT from '../NFT/NFT';
import NFTDetail from '../NFT/NFTDetail';
import isElectron from '../../Global';
import FaceImage from '../Setting/FaceImage';
import Loading from '../Loading/Loading';
import { useTranslation } from 'react-i18next';
import LiveWalletConnect from './LiveWalletConnect';
import DataModel from '../Util/DataModel';
import { ReactComponent as MoreSVG } from '../Images/buttons/moreButton.svg';

import NFTItem from '../NFT/NFTItem';
import '../Recorded/Recorded.css';

export default function Live({ joinCall, preAuthCompleteState, liveData, roomID }) {
  //daily系
  const callObject = useDaily();
  const { t, i18n } = useTranslation();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);

  //その他
  const [noNameErrorState, setNoNameErrorState] = useState(false);
  const [isEndState, setIsEndState] = useState(false);
  const [liveDateState, setLiveDateState] = useState(null);
  const [isLoadingState, setIsLoadingState] = useState(true);
  const [showTokenGated, setShowTokenGated] = useState(false);
  const [tokenGatedType, setTokenGatedType] = useState(null);
  const [isPaid, setIsPaid] = useState(false);
  const [recordedVideoState, setRecordedVideoState] = useState([]);

  var is3 = false;
  if (
    myNftState == 'defaultkun' ||
    myNftState == 'facelessgirl' ||
    myNftState == 'ethereum-0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d-9899'
  ) {
    is3 = true;
  }
  //初期化
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    initGet();
  }, [liveData]);

  async function initGet() {
    if (liveData != null) {
      // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
      // console.log(liveData.liveDate);
      // console.log(liveData.liveDate.toDate().toLocaleTimeString('en-US'));

      //開始時間
      let date = new Date(liveData?.liveDate?._seconds * 1000);

      let formatDate;
      if (i18n.language == 'ja') {
        formatDate = format(
          date,
          'MM' + '月' + 'dd' + '日 ' + 'h' + '時' + 'mm' + '' + 'a' + ' 開始',
        );
      } else {
        formatDate = format(date, 'MMM do hh:mm a');
      }

      //日時の設定
      setLiveDateState(formatDate);

      //ステータス表示 (終了検知)
      if (liveData?.status != null && liveData?.status == 'ended') {
        setIsEndState(true);
        await getRecordedVideo();
      }

      //トークンゲイト
      if (liveData?.isTokenGated != null && liveData?.isTokenGated) {
        setShowTokenGated(true);
        if (localStorage.getItem('isAdmin') != null) {
          setShowTokenGated(false);
        }
      }

      //トークンゲイトのタイプ
      if (liveData?.tokenGatedType != null && liveData?.tokenGatedType) {
        setTokenGatedType(liveData?.tokenGatedType);
      }

      //有料かどうか
      if (liveData?.isPaid != null && liveData?.isPaid) {
        setIsPaid(liveData?.isPaid);
      }

      //ローディング表示隠す
      setIsLoadingState(false);
    }
  }

  async function getRecordedVideo() {
    const recordedVideo = await DataModel.getRecordedVideo(roomID);

    if (recordedVideo != null) {
      if (recordedVideo.length > 0) {
        setRecordedVideoState(recordedVideo);
      }
    }

    return;
  }

  //初期化
  const init = async (e) => {
    // if (localStorage.getItem('displayName') != null) {
    //   oldDisplayNameRef.current = localStorage.getItem('displayName');
    //   setDisplayNameState(localStorage.getItem('displayName'));
    // }

    if (localStorage.getItem('imageURL') != null) {
      setMyNftState(localStorage.getItem('imageURL'));
    } else {
      localStorage.setItem('imageURL', 'defaultkun');
      setMyNftState('defaultkun');
    }

    if (localStorage.getItem('nftID') == null) {
      localStorage.setItem('nftID', 'defaultkun');
    }
  };

  //ユーザー名を設定
  const onUserNameChange = (e) => {
    //フォームの値を更新
    setDisplayNameState(e.target.value);
  };

  //ルームに参加
  const join = async (e) => {
    e.preventDefault();

    if (preAuthCompleteState == false) return;

    //名前の入力がない場合はエラー
    if (displayNameState == null || displayNameState == '') {
      setNoNameErrorState(true);
      return;
    }

    //コールオブジェクトに名前を設定
    callObject.setUserName(displayNameState);

    //ローカルストレージ更新
    localStorage.setItem('displayName', displayNameState);

    //参加
    joinCall();
  };

  const toggleNFT = (e) => {
    e.preventDefault();
    setPageState('nftList');
  };

  //画像をクリック
  const clipImage = async (e) => {
    return;
    setPageState('nftList');
  };

  return (
    <>
      {/* NFTリスト　*/}
      {pageState == 'nftList' && <NFT userType={'viewer'} />}
      {/*NFT詳細画面*/}
      {pageState == 'nftDetail' && <NFTDetail />}
      {/*ローディング中*/}
      <Loading loadingState={isLoadingState} />
      <div id="liveBack">
        <div id="liveWrap">
          {/* <div id="liveTitle">{liveData?.liveTitle ?? 'Loading...'}</div>
          <div id="liveDate"> {liveDateState ?? '-- --- ---'}</div> */}

          <div id="recordVideoLeft" style={{ gridTemplateColumns: '85px 1fr', marginLeft: '0px' }}>
            <FaceImage myNftState={liveData?.liveImageURL} />
            <div>
              <div id="recordVideoTitle">{liveData?.liveTitle ?? 'Loading...'}</div>
              <div id="recordVideoDate">{liveDateState ?? '-- --- ---'}</div>
            </div>
          </div>

          {/*トークンゲート*/}
          {showTokenGated == false ? (
            <>
              {/*既に終了している場合*/}
              {isEndState ? (
                <>
                  <div id="nftNoExist">{t('live.Live was ended')}</div>
                  {/*アーカイブ動画一覧*/}
                  {recordedVideoState.map((recordedID, index) => (
                    <div id="liveButton" key={index}>
                      <button
                        onClick={() => {
                          window.location.href = 'https://faceless.ooo/r/' + recordedID;
                        }}>
                        {t('live.Watch a video')}
                        {index != 0 && [index + 1]}
                      </button>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <div id="liveInputTitle" style={{ marginTop: '20px' }}>
                    {t('haircheck.Display Name')}
                  </div>
                  <div id="liveInput">
                    <input
                      name="username"
                      type="text"
                      placeholder={t('haircheck.Type Display Name')}
                      onChange={(e) => onUserNameChange(e)}
                      value={displayNameState ?? ''}
                    />
                  </div>
                  {/* エラーメッセージ */}
                  {noNameErrorState && (
                    <div
                      id="hairCheckError"
                      style={{ marginTop: '10px', textAlign: 'left', marginBottom: '0px' }}>
                      {t('haircheck.Value can’t be empty.')}
                    </div>
                  )}
                  <div id="liveSelectWrap">
                    <label htmlFor="username" className="hairCheckTitle">
                      <>{t('haircheck.Select Avatar')}</>
                    </label>
                    <div className="renew">
                      <div id="hairCheckNFT" style={{ marginBottom: '3px' }}>
                        <NFTItem
                          imageURL={'boy'}
                          thumbURL={'images/nft/thumb/facelesskun.png'}
                          type={'pro'}
                          nftID="defaultkun"
                        />
                        {/* 
                      <NFTItem
                        imageURL={'sidegirl'}
                        thumbURL={'images/nft/thumb/sidegirl.png'}
                        type={'pro'}
                        nftID="facelessgirl"
                      />
                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d-9899"
                      /> */}

                        <div className="nftItem" onClick={toggleNFT}>
                          {is3 ? (
                            <MoreSVG />
                          ) : (
                            <>
                              <NFTItem
                                imageURL={'timeless'}
                                thumbURL={'images/nft/thumb/timeless.png'}
                                type={'pro'}
                                nftID={myNftState}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="liveButton">
                    <button onClick={join}>
                      {preAuthCompleteState ? (
                        <>{t('haircheck.Join Now')}</>
                      ) : (
                        <>
                          <div id="selectLoader">
                            <svg className="circular-loader" viewBox="25 25 50 50">
                              <circle
                                className="loader-path"
                                cx="50"
                                cy="50"
                                r="20"
                                fill="none"
                                stroke="#70c542"
                                strokeWidth="2"
                              />
                            </svg>
                          </div>
                        </>
                      )}
                    </button>
                  </div>
                </>
              )}
            </>
          ) : (
            <LiveWalletConnect
              liveData={liveData}
              roomID={roomID}
              setShowTokenGated={setShowTokenGated}
              tokenGatedType={tokenGatedType}
              isPaid={isPaid}
            />
          )}
        </div>
      </div>
    </>
  );
}
